<template>
  <div id="geetest-box" />
</template>

<script>
import Vue from 'vue'
import { getGeetestVerification } from 'apis/oauth'
import './gt.js'

const geetLangMap = {
  'en-us': 'en',
  'zh-cn': 'zh-cn'
}
export default {
  name: 'GeetestCheck',
  computed: {
    language() {
      const lang = this.$store.state.settings.language
      return geetLangMap[lang]
    }
  },
  data() {
    return {
      loading: false
    }
  },
  props: {
    target: {
      type: String,
      default: ''
    }
  },
  methods: {
    async init() {
      if (this.loading) return
      this.loading = true
      const self = this
      try {
        Vue.log('Geetest start')
        const res = await getGeetestVerification()
        if (res.data.data) {
          const data = res.data.data
          const config = {
            gt: data.gt,
            challenge: data.challenge,
            offline: !data.success,
            new_captcha: true,
            geetest_challenge_id: data.geetest_challenge_id,
            product: 'bind',
            lang: self.language,
            bg_color: '#fff',
            next_width: '300px',
            https: true
          }
          if (self.target) {
            config.area = self.target
          }
          Vue.log(`Geetest init ${data.challenge}`)
          window.initGeetest(config, captchaObj => {
            captchaObj.onReady(() => {
              captchaObj.verify() // 显示验证码
              self.$emit('ready')
            })
            captchaObj.onSuccess(async () => {
              const result = await captchaObj.getValidate()
              const sucData = {
                ...result,
                geetest_challenge_id: data.geetest_challenge_id
              }
              self.loading = false
              self.$emit('validate-pass', sucData)
            })
            captchaObj.onError(error => {
              captchaObj.reset()
              Vue.log(
                `Geetest verify error: ${JSON.stringify(error)}, challenge: ${
                  data.challenge
                }`
              )
              self.$emit('validate-error', error)
            })
            captchaObj.onClose(() => {
              self.loading = false
              self.$emit('validate-close')
            })
          })
        } else {
          throw res.data
        }
      } catch (error) {
        this.$emit('validate-error', error)
        Vue.log(`Geetest init error: ${JSON.stringify(error)}`)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less">
.geetest-box {
  width: 0;
  height: 0;
}
</style>
